"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useColumns = exports.useStyles = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
const context_help_1 = require("../../components/context-help/context-help");
const table_field_cells_1 = require("../../components/table-field/table-field-cells");
const checkbox_cell_1 = require("./column-cells/checkbox-cell");
const date_cell_1 = require("./column-cells/date-cell");
const key_value_cell_1 = require("./column-cells/key-value-cell");
const number_cell_1 = require("./column-cells/number-cell");
const select_cell_1 = require("./column-cells/select-cell");
const text_cell_1 = require("./column-cells/text-cell");
const internal_settings_context_1 = require("./internal-settings-context");
const internal_settings_types_1 = require("./internal-settings-types");
exports.useStyles = (0, makeStyles_1.default)(() => ({
    columnNameWrapper: {
        display: 'flex',
        alignItems: 'center',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
    },
    columnValueWrapper: { display: 'flex', gap: '10px', width: '100%' },
}));
function useColumns(collectionDatakey) {
    const intl = (0, react_intl_1.useIntl)();
    const { config } = (0, react_1.useContext)(internal_settings_context_1.InternalSettingsConfigContext);
    const classes = (0, exports.useStyles)();
    const columns = (0, react_1.useMemo)(() => [
        {
            datakey: 'name',
            name: intl.formatMessage({
                id: 'EAS__INTERNAL_SETTINGS__COLUMN__NAME',
                defaultMessage: 'Název',
            }),
            width: 400,
            CellComponent: function Cell(props) {
                var _a;
                return (react_1.default.createElement("div", { className: classes.columnNameWrapper },
                    react_1.default.createElement(table_field_cells_1.TableFieldCells.TextCell, { ...props }),
                    react_1.default.createElement(context_help_1.ContextHelp, { label: (_a = props === null || props === void 0 ? void 0 : props.rowValue) === null || _a === void 0 ? void 0 : _a.description, type: "HOVER" })));
            },
        },
        {
            datakey: 'value',
            name: intl.formatMessage({
                id: 'EAS__INTERNAL_SETTINGS__COLUMN__VALUE',
                defaultMessage: 'Hodnota',
            }),
            width: 400,
            CellComponent: function Cell(props) {
                var _a, _b, _c, _d;
                const DefaultCell = deriveValueDefaultCell(props.rowValue)({
                    collectionDatakey,
                    disabled: true,
                });
                const Cell = (_c = (_b = (_a = config === null || config === void 0 ? void 0 : config.find((setting) => setting.code === props.rowValue.code)) === null || _a === void 0 ? void 0 : _a.ColumnCell) === null || _b === void 0 ? void 0 : _b.call(_a, {
                    collectionDatakey,
                    disabled: true,
                })) !== null && _c !== void 0 ? _c : DefaultCell;
                return (react_1.default.createElement("span", { className: classes.columnValueWrapper },
                    react_1.default.createElement(Cell, { ...props }),
                    ((_d = props.rowValue) === null || _d === void 0 ? void 0 : _d.unit) && (react_1.default.createElement(Typography_1.default, null, props.rowValue.unit))));
            },
        },
        {
            datakey: 'comment',
            name: intl.formatMessage({
                id: 'EAS__INTERNAL_SETTINGS__COLUMN__COMMENT',
                defaultMessage: 'Komentář',
            }),
            width: 300,
            CellComponent: table_field_cells_1.TableFieldCells.TextCell,
        },
        {
            datakey: 'updated',
            name: intl.formatMessage({
                id: 'EAS__INTERNAL_SETTINGS__COLUMN__UPDATED',
                defaultMessage: 'Poslední úprava',
            }),
            width: 150,
            CellComponent: table_field_cells_1.TableFieldCells.DateTimeCell,
        },
        {
            datakey: 'updatedBy.name',
            name: intl.formatMessage({
                id: 'EAS__INTERNAL_SETTINGS__COLUMN__UPDATED_BY',
                defaultMessage: 'Autor úpravy',
            }),
            width: 150,
            CellComponent: table_field_cells_1.TableFieldCells.TextCell,
        },
    ], 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [intl, collectionDatakey, config]);
    return columns;
}
exports.useColumns = useColumns;
const deriveValueDefaultCell = ({ inputType, collection }) => {
    switch (inputType.name) {
        case internal_settings_types_1.SimpleEasSettingInputType.CHECKBOX:
            return checkbox_cell_1.CheckboxCell;
        case internal_settings_types_1.SimpleEasSettingInputType.DATE:
            return date_cell_1.LocalDateCell;
        case internal_settings_types_1.SimpleEasSettingInputType.DATE_TIME:
            return date_cell_1.LocalDateTimeCell;
        case internal_settings_types_1.SimpleEasSettingInputType.INSTANT:
            return date_cell_1.InstantCell;
        case internal_settings_types_1.SimpleEasSettingInputType.INTEGER:
            return collection ? number_cell_1.NumberMultipleCell : number_cell_1.NumberCell;
        case internal_settings_types_1.SimpleEasSettingInputType.SELECT:
            return select_cell_1.SelectOptionsCell;
        case internal_settings_types_1.SimpleEasSettingInputType.KEY_VALUE_MAP:
            return key_value_cell_1.KeyValueCell;
        default:
            return collection ? text_cell_1.TextMultipleCell : text_cell_1.TextCell;
    }
};
//# sourceMappingURL=internal-settings-columns.js.map